import axios from "axios";
import * as url from "../helpers/url_helper";
import { APIClient } from "../helpers/api_helper";
import { useLayoutEffect } from "react";

const api = new APIClient();

export const getDailyReportService = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const finalUrl = `${url.GET_DAILY_REPORT}?${query}`;

  return axios.post(finalUrl, params, {
    responseType: "arraybuffer",
  });
};

export const getDailyGSTReportService = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const finalUrl = `${url.GET_DAILY_GST_REPORT}?${query}`;

  return axios.post(finalUrl, params, {
    responseType: "arraybuffer",
  });
};

export const getDailyOtherReportService = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const finalUrl = `${url.GET_DAILY_OTHER_REPORT}?${query}`;

  return axios.post(finalUrl, params, {
    responseType: "arraybuffer",
  });
};

export const getLedgerReportService = (queryParam) => {
  // return api.create(url.DOWNLOAD_LEDGER, queryParam, false, {}, true);

  // const query = new URLSearchParams(queryParam).toString();
  // const finalUrl = `${url.DOWNLOAD_LEDGER}?${query}`;
  return axios.post(url.DOWNLOAD_LEDGER, queryParam, {
    withCredentials: true,
    responseType: "arraybuffer",
    headers: {
      Accept: "*/*",
    },
  });

  // return api.get(url.DOWNLOAD_LEDGER, queryParam, {
  //   withCredentials: true,
  //   responseType: "arraybuffer",
  //   headers: {
  //     Accept: "application/pdf",
  //   },
  // });
};

export const uploadExcelService = (formData) => {
  return api.create(url.UPLOAD_EXCEL, formData);
};

// export const addSessionService = (requestParams = {}) => {
//   return api.create(url.ADD_SESSIONS, requestParams);
// };

// export const deleteSessionService = (id) => {
//   return api.delete(url.DELETE_SESSION(id));
// };

// export const editSessionService = (queryParams) => {
//   return api.create(url.EDIT_SESSION, queryParams);
// };

// export const updateSessionStatusService = (id, status, data = {}) => {
//   return api.put(url.PUT_SESSION_STATUS(id), data, status, true);
// };

// export const getCategoryByIdService=(id)=>{
//   return api.get(url.GET_MEAL_CATEGORY(id));
// }
